var map = {
	"./LangLoader.js": "4x6F",
	"./en.js": "p9le",
	"./es.js": "vYuL"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Q/bJ";


//////////////////
// WEBPACK FOOTER
// ./src/lang nonrecursive \.js$
// module id = Q/bJ
// module chunks = 0